module.exports = __webpack_public_path__ + "img/jiuchen.4bd4c2c5.png";